import React from 'react';
import LargeButton from '../../shared/components/LargeButton';
import { useNavigate } from 'react-router-dom';
import { Page } from '../../layout';
import PrivilegeNames from '../../../constants/privilegeNames';
import { useReactiveVar } from '@apollo/client';
import { userLicensedOrgUnitId, userPrivileges, systemRole } from '../../../apollo/cache';
import { getUnitSearchForAppraisalComparison } from '../../shared/services/getUnitSearchPageUrlService';
import { Breadcrumb } from '../../shared/components/breadcrumb/Breadcrumb';
import { getRoleAdjustedUrl } from '../../shared/services/getIndustryReportsPageUrlService';
import { getAdjustedBreadcrumbPathItems } from '../../shared/services/breadcrumbService';

const IndustryReportsNavigationPage = () => {
  const privileges = useReactiveVar(userPrivileges);
  const role = useReactiveVar(systemRole);
  const orgUnitId = useReactiveVar(userLicensedOrgUnitId);

  const pageTitle = 'Industry Reports';
  const breadcrumbPathItems = [
    { name: 'Data Reports', url: '/data-reports' },
    {
      name: pageTitle,
      url: '/data-reports/industry-reports'
    }
  ];
  const adjustedBreadcrumbPathItems = getAdjustedBreadcrumbPathItems(breadcrumbPathItems, role.Id);

  const navigate = useNavigate();

  return (
    <Page title={pageTitle}>
      <Breadcrumb pathItems={adjustedBreadcrumbPathItems} />

      <div className='reports-page-navigation'>
        <h2>Which Industry Report would you like to view?</h2>
        <div className='reports-page-navigation__controls'>
          {privileges && privileges.includes(PrivilegeNames.BaseLine) && (
            <LargeButton
              onClick={() =>
                navigate(getRoleAdjustedUrl('/data-reports/industry-reports/baseline', role.Id))
              }
              subText='See the industry baseline view'>
              Baseline
            </LargeButton>
          )}

          {privileges && privileges.includes(PrivilegeNames.AppraisalComparison) && (
            <LargeButton
              onClick={() => navigate(getUnitSearchForAppraisalComparison(privileges, orgUnitId))}
              subText={
                privileges.includes(PrivilegeNames.UnitSearch)
                  ? 'See how appraisal results compare'
                  : 'See how your appraisal results compare'
              }>
              Appraisal Comparison
            </LargeButton>
          )}

          {privileges && privileges.includes(PrivilegeNames.AppraisalView) && (
            <LargeButton
              onClick={() =>
                navigate(
                  getRoleAdjustedUrl('/data-reports/industry-reports/customization', role.Id)
                )
              }
              subText='Create a customized report'>
              Appraisal View
            </LargeButton>
          )}
          {privileges && privileges.includes(PrivilegeNames.StrengthsAndChallenges) && (
            <LargeButton
              onClick={() =>
                navigate(
                  getRoleAdjustedUrl('/data-reports/industry-reports/strengths-challenges', role.Id)
                )
              }
              subText='View trends in the industry'>
              Strengths and Challenges
            </LargeButton>
          )}

          {privileges && privileges.includes(PrivilegeNames.AggregatePerformanceReport) && (
            <LargeButton
              onClick={() =>
                navigate(
                  getRoleAdjustedUrl(
                    '/data-reports/industry-reports/aggregate-performance-report',
                    role.Id
                  )
                )
              }
              subText='View commonly reported metrics'>
              Aggregate Performance Report
            </LargeButton>
          )}

          {privileges && privileges.includes(PrivilegeNames.DataCorrelations) && (
            <LargeButton
              onClick={() =>
                navigate(
                  getRoleAdjustedUrl('/data-reports/industry-reports/data-correlations', role.Id)
                )
              }
              subText='Correlations between aggregate performance and appraisal data'>
              Data Correlations
            </LargeButton>
          )}
        </div>
      </div>
    </Page>
  );
};

export default IndustryReportsNavigationPage;
